import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
};

const twoFactorOnboardingSlice = createSlice({
  name: 'twoFactorOnboarding',
  initialState,
  reducers: {
    setTwoFactorOnboardingState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetTwoFactorOnboardingState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => initialState);
  },
});

export const { setTwoFactorOnboardingState, resetTwoFactorOnboardingState } =
  twoFactorOnboardingSlice.actions;
export default twoFactorOnboardingSlice.reducer;
